import React, { useState, useMemo } from 'react';
import AddBox from '@mui/icons-material/Add';
import MinusBox from '@mui/icons-material/Remove';
import { Box, Divider, StyledEngineProvider } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '..';

type CollapsibleSectionProps = {
  headerText: string;
  noCollapsible?: boolean;
  showHeader?: boolean;
  className?: string;
  children: React.ReactNode;
};

const useStyles = makeStyles(() => ({
  dividerRoot: {
    flex: 1,
  },
  pointerCursor: {
    cursor: 'pointer',
  },
}));

function CollapsibleSection(props: CollapsibleSectionProps) {
  const {
    headerText,
    noCollapsible = false,
    showHeader = true,
    children,
    className,
  } = props;

  const [isOpen, setOpen] = useState(noCollapsible);
  const toggleOpen = useMemo(
    () => (noCollapsible ? null : () => setOpen(c => !c)),
    [noCollapsible],
  );

  const { dividerRoot, pointerCursor } = useStyles();

  return (
    <StyledEngineProvider injectFirst>
      <Box my={2} className={className}>
        {showHeader && (
          <Box
            display="flex"
            alignItems="center"
            gap="8px"
            className={`mb-5 ${pointerCursor}`}
            onClick={toggleOpen}
          >
            {!noCollapsible &&
              (isOpen ? (
                <MinusBox color="primary" className="!text-base" />
              ) : (
                <AddBox color="primary" className="!text-base" />
              ))}

            <Typography fb themeColor={'primary.main'}>
              {headerText}
            </Typography>

            <Divider classes={{ root: dividerRoot }} />
          </Box>
        )}
        {noCollapsible || isOpen ? <Box>{children}</Box> : null}
      </Box>
    </StyledEngineProvider>
  );
}

export default CollapsibleSection;
